import styled from 'styled-components';
import { COLORS } from '@Commons';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 650px;
  .convert-btn-skeleton {
    margin-top: 24px;
  }
`;

export const BoxSkeleton = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  border-radius: 12px;
  border: 1px solid ${COLORS.borderbottomtext};
  background: ${COLORS.white};
  gap: 16px;
`;

export const LeftContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
`;

export const RightContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;
